import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes with conflict resolution.
 *
 * `clsx` flattens the conditional-class API; `tailwind-merge` then
 * de-duplicates / overrides conflicting Tailwind utilities (so a
 * later `bg-red-500` wins over an earlier `bg-blue-500`).
 *
 * Every primitive in this package uses `cn` for its className prop
 * composition. Consumers can also use it directly.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
